import useCompanyId from 'hooks/useCompanyId';
import usePosDomains from 'hooks/usePosDomains';

// The Invite Co-Borrower action is hidden without a POS domain, so a fetch failure (which
// usePosDomains reports as an empty list) correctly degrades to false.
const useHasPosDomain = () => {
  const companyId = useCompanyId();

  return !!usePosDomains(companyId).length;
};

export default useHasPosDomain;
